import type { UnmappedWord, UpstreamAttribute, UpstreamAttributeView, UpstreamCatalog } from '@fitting-room/contracts'

/**
 * The few words Words from Airtable shares between the Sync gowns panel and
 * the Catalog page's list. Console copy, so it lives beside the console.
 */

export const CATALOG_LABEL: Record<UpstreamCatalog, string> = {
  made_to_order: 'Made to order',
  off_the_rack: 'Off the rack',
}

/** Spelled out rather than read from the contract's enum: see the note in `CataloguePage`. */
const FALLBACK_NOUN: Record<UpstreamAttribute, string> = {
  silhouette: 'silhouette',
  neckline: 'neckline',
  detail: 'detail',
}

/** "neckline", from the tenant's own label when there is one. */
export function attributeNoun(view: UpstreamAttributeView | undefined, key: UpstreamAttribute): string {
  return view ? view.label.toLowerCase() : FALLBACK_NOUN[key]
}

/** "Used by 2 styles" for made to order, "on 1 piece" off the rack. */
export function styleCount(word: UnmappedWord): string {
  const n = word.styles.length
  return word.catalog === 'made_to_order'
    ? `Used by ${n} ${n === 1 ? 'style' : 'styles'}`
    : `On ${n} ${n === 1 ? 'piece' : 'pieces'}`
}
